import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/layout/SmoothScroll";
import CustomCursor from "@/components/layout/CustomCursor";
import Aurora from "@/components/layout/Aurora";
import BrandProvider from "@/components/BrandProvider";
import AnnouncementBar from "@/components/layout/AnnouncementBar";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Loader from "@/components/ui-custom/Loader";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import PricingPage from "@/pages/PricingPage";
import About from "@/pages/About";
import WhiteLabel from "@/pages/WhiteLabel";
import Api from "@/pages/Api";
import Contact from "@/pages/Contact";
import FaqPage from "@/pages/FaqPage";
import Blog from "@/pages/Blog";
import Support from "@/pages/Support";
import Legal from "@/pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Page({ children }) {
  return (
    <motion.main
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.main>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Page><Home /></Page>} />
        <Route path="/services" element={<Page><Services /></Page>} />
        <Route path="/pricing" element={<Page><PricingPage /></Page>} />
        <Route path="/about" element={<Page><About /></Page>} />
        <Route path="/white-label" element={<Page><WhiteLabel /></Page>} />
        <Route path="/developers" element={<Page><Api /></Page>} />
        <Route path="/contact" element={<Page><Contact /></Page>} />
        <Route path="/faq" element={<Page><FaqPage /></Page>} />
        <Route path="/blog" element={<Page><Blog /></Page>} />
        <Route path="/support" element={<Page><Support /></Page>} />
        <Route path="/terms" element={<Page><Legal type="terms" /></Page>} />
        <Route path="/privacy" element={<Page><Legal type="privacy" /></Page>} />
        <Route path="*" element={<Page><Home /></Page>} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <div className="App relative min-h-screen">
      <BrandProvider>
        <Loader />
        <Aurora />
        <CustomCursor />
        <Toaster theme="light" position="top-right" richColors />
        <BrowserRouter>
          <SmoothScroll>
            <ScrollToTop />
            <AnnouncementBar />
            <Navbar />
            <AnimatedRoutes />
            <Footer />
          </SmoothScroll>
        </BrowserRouter>
      </BrandProvider>
    </div>
  );
}
